import { Button, Col, Popover, Row } from "antd";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { IBrandSummaryData } from "../../../../Models/IBrandSummaryData";
import { RetailMatchBrandCardBottomRow } from "../Styled/RetailMatchBrandCardBottomRow";
import { RetailMatchBrandCardWrapper } from "../Styled/RetailMatchBrandCardWrapper";
import { brandLinkURL, TOO_FEW_RECORD_EXPLANATION } from "../Util/RetailMatchUtil";

interface IRetailMatchBrandCardProps {
    jobId: string;
    rank: number;
    isSharing: boolean;
    brandSummary: IBrandSummaryData;
}

const RetailMatchBrandCard = (props: IRetailMatchBrandCardProps): JSX.Element => {

    const location = useLocation();

    const button = (
        <Button disabled={props.brandSummary.tooFewRecords}>
            {props.brandSummary.tooFewRecords
                ? "Unavailable"
                : "View Complete Analysis"}
        </Button>
    );

    return (
        <RetailMatchBrandCardWrapper>
            <Row gutter={[0, 6]}>
                <Col span={24}>
                    <img
                        src={props.brandSummary.brand.logoPath}
                        style={{
                            width: "60px",
                        }}
                    />
                </Col>
            </Row>
            <Row gutter={[0, 25]}>
                <Col span={24}>
                    <h2>
                        #{props.rank}. {props.brandSummary.brand.brandName}
                    </h2>
                </Col>
            </Row>
            <RetailMatchBrandCardBottomRow>
                <Col span={24}>
                    {props.brandSummary.tooFewRecords ? (
                        <Popover placement="top" content={TOO_FEW_RECORD_EXPLANATION}>
                            {button}
                        </Popover>
                    ) : (
                        <Link
                            to={brandLinkURL(
                                location.pathname,
                                props.isSharing,
                                props.jobId,
                                props.brandSummary.brand.brandId
                            )}
                        >
                            {button}
                        </Link>
                    )}
                </Col>
            </RetailMatchBrandCardBottomRow>
        </RetailMatchBrandCardWrapper>
    );
};

export default RetailMatchBrandCard;
